import { RegionManager } from 'backbone.marionette';

import { ReceiptAccountsView } from '../views/accounts';

module.exports =  function (options) {

  var regions = new RegionManager({
    regions: {
      create_contact_region: '#manage-accounts-hook'
    }
  }); 
  

  var button = regions.get('create_contact_region');
  button.show(new ReceiptAccountsView(options));
};


// WEBPACK FOOTER //
// ./receipt/initializers/accounts.js